<template>
	<a v-if="!isPodcast" :href="item.link" target="_blank">
		<v-card class="rss-card pa-4 elevation-0">
			<div class="rss-card__picture-wrapper" v-if="item.picture">
				<img class="rss-card__picture" :src="pictureSrc" />
			</div>
			<div class="rss-card__info">
				<v-card-text
					:class="{
						'rss-card__info-date mb-1': true,
						'rss-card__info-date-left': !item.picture && !isPodcast,
					}"
				>
					{{ createdDate }}
				</v-card-text>
				<v-card-title class="rss-card__info-title">
					{{ item.title }}
				</v-card-title>
				<v-card-text class="rss-card__info-text">
					{{ item.text }}
				</v-card-text>
			</div>
			<div v-if="!isPodcast" class="rss-card__chevron-wrapper">
				<Icon type="chevron_right" color="#9B9B9B" :size="16" />
			</div>
		</v-card>
	</a>
	<v-card v-else class="rss-card pa-4 elevation-0">
		<div class="rss-card__picture-wrapper" v-if="item.picture || (!item.picture && isPodcast)">
			<img class="rss-card__picture" :src="pictureSrc" />
			<div v-if="isPodcast" class="rss-card__play-btn" @click="handlePodcastClick">
				<Icon :type="play ? 'pause' : 'play'" color="white" :size="24" />
			</div>
		</div>
		<div class="rss-card__info">
			<v-card-text
				:class="{
					'rss-card__info-date mb-1': true,
					'rss-card__info-date-left': !item.picture && !isPodcast,
				}"
			>
				{{ createdDate }}
			</v-card-text>
			<v-card-title class="rss-card__info-title">
				{{ item.title }}
			</v-card-title>
			<v-card-text class="rss-card__info-text">
				{{ item.text }}
			</v-card-text>
		</div>
		<div v-if="!isPodcast" class="rss-card__chevron-wrapper">
			<Icon type="chevron_right" color="#9B9B9B" :size="16" />
		</div>
	</v-card>
</template>
<script>
import moment from 'moment'
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import podcastImg from '@/assets/images/podcast.svg'

export default {
	props: {
		isPodcast: {
			type: Boolean,
			default: false,
		},
		item: {
			type: Object,
			default: () => {},
		},
		podcasts: {
			type: Array,
			default: () => [],
		},
		index: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			podcastImg,
		}
	},
	computed: {
		...mapGetters('rss', ['playlist', 'currentPodcast', 'play']),

		createdDate() {
			return moment(this.item.date * 1000).fromNow()
		},
		isCurrentPodcast() {
			return _.isEqual(this.item, this.currentPodcast)
		},
		pictureSrc() {
			return this.item.picture || this.podcastImg
		},
	},
	methods: {
		...mapActions('rss', ['setPodcast', 'togglePlay']),

		handlePodcastClick() {
			if (this.isCurrentPodcast) {
				this.togglePlay(!this.play)
			} else {
				this.setPodcast({
					podcast: this.item,
					playlist: this.podcasts,
					podcastNumber: this.index,
				})
				!this.play && this.togglePlay(true)
			}
		},
	},
}
</script>
<style lang="scss">
.rss-card {
	justify-content: space-between !important;
	display: flex;
	flex-wrap: nowrap;
	align-items: flex-start;
	margin-bottom: 8px;
	border-radius: 10px !important;

	@media (max-width: 600px) {
		flex-direction: column;
		align-items: center;
	}

	&__picture {
		width: 148px;
		height: 148px;
		background-color: #aaa;
		object-fit: cover;
		border-radius: 8px;

		&-wrapper {
			position: relative;
			display: flex;
			justify-content: center;
			align-items: center;
			margin-right: 16px;

			@media (max-width: 600px) {
				margin: 0;
			}
		}
	}

	&__info {
		display: flex;
		flex-direction: column;
		font-family: Montserrat, sans-serif;

		&-date {
			font-size: 13px;
			line-height: 19.37px;
			color: #697583;

			&-left {
				text-align: left !important;
			}

			@media (max-width: 600px) {
				margin-top: 4px;
				text-align: center;
			}
		}

		&-title {
			font-size: 18px;
			font-weight: 700;
			color: var(--accent-color);
			line-height: 21.94px;
			padding: 0;
			margin-bottom: 10px;
			word-break: break-word;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;

			@media (max-width: 600px) {
				font-size: 14px;
			}
		}

		&-text {
			font-size: 14px;
			color: var(--accent-color);
			line-height: 17.07px;
			word-break: break-word;
		}
	}

	&__chevron {
		&-wrapper {
			align-self: center;
			margin-left: 12px;
			@media (max-width: 600px) {
				display: none !important;
			}
		}
	}

	&__play-btn {
		height: 52px;
		width: 52px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: var(--accent-color);
		border-radius: 50%;
		border: 2px solid #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: all 0.2s ease;

		&:hover {
			box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

			i {
				transform: scale(1.2);
			}
		}
	}
}
</style>
